var map = {
	"./V1/Scoreboard.vue": [
		1715,
		715
	],
	"./V2/CommandScore.vue": [
		867,
		867
	],
	"./V2/NextFights.vue": [
		8879,
		879
	],
	"./V2/Scoreboard.vue": [
		262,
		262
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 3457;
module.exports = webpackAsyncContext;